import { composeIO } from 'react-compose-io'
import { fieldsBuscarLinhaTransformacaoApiIO } from './FieldsBuscarLinhaTransformacaoApi.IO'
import FieldsBuscarLinhaTransformacaoApiView from './FieldsBuscarLinhaTransformacaoApi.View'

export const FieldsBuscarLinhaTransformacaoApi = composeIO(FieldsBuscarLinhaTransformacaoApiView, fieldsBuscarLinhaTransformacaoApiIO)
